import { useState,useEffect } from "react";
import { useParams,useLocation,Link } from "react-router-dom";
import { useSelector } from "react-redux";
import Heading from "../component/ui/Heading.js";
import Loader from "../component/ui/Loader.js";
import ThumbnailCard from "../component/ThumbnailCard/ThumbnailCard.js";
import MediaMainBG from "../component/MediaMainBG/MediaMainBG.js";
import PreviewImage from "../component/previews/PreviewImage.js";
import Button from "../component/ui/Button.js";
// import { skipToken } from "@reduxjs/toolkit/query";
import { useGetPlaylistsByCategoryAndNetworkQuery } from "../services/modules/playlistCategory"
import { useGetAllPlaylistCategoriesQuery } from "../services/modules/playlistCategory";

import { titleToKey } from "../services/utils/helpers.js"


export default function AllPlaylist() {
  const { id } = useParams();
  const categoryId = id.toString();

  const { data: categoriesRawPlayList = {},isLoading: isLoadingCategoriesPlayList,error: errorCategoriesPlayList,} = useGetAllPlaylistCategoriesQuery();
  const allCategoriesPlayList = categoriesRawPlayList?.data?.result || [];
const coverImage = (allCategoriesPlayList.find(c => c.id == categoryId && c.coverImage) || {}).coverImage;
  const title=allCategoriesPlayList.filter(c =>  c.id == categoryId && c.name).map(c => c.name)

  const { data,isLoading,error } = useGetPlaylistsByCategoryAndNetworkQuery({ categoryId: categoryId });


  const videos = (() => {
    const result = data?.data?.result;
    if (Array.isArray(result?.playlists)) {
      return result.playlists.map((video) => ({
        id: video.id,
        title: video.name,
        thumbnail: video.coverImage,
        rating: 0,
        url: null,
        description: video.description,
        createdAt: video.createdAt,
        categories: Array.isArray(video.playlistCategory) ? video.playlistCategory : [],
        videos: {
          coverImage: video.coverImage,
          videos: video.videos.map((video) => ({
            id: video.videoId,
            title: video.video.title,
            thumbnail: video.video.thumbnail,
            rating: video.video.rating || 0,
            url: video.video.url,
            description: video.video.description,
            createdAt: video.video.createdAt,
            categories: Array.isArray(video.video.categories) ? video.video.categories : [],
          }))
        }
      }));
    }

    return [];
  })();


  return (
    <div className="flex h-full">
      <div className="space-y-8 flex-1 p-8">
        <Heading>
          {title|| "Playlist"}
        </Heading>
        <MediaMainBG type="movies" coverImage={coverImage} />
<div className="flex flex-wrap gap-6 justify-start content-start">
          {videos.map((video,index) => (
            <div
              key={video.id}
              style={{ flexBasis: 300 }}
              className="block flex-shrink-0 rounded-lg overflow-x-hidden max-w-[350px] w-full"
            >
              <Link
                to={`/playlist/${titleToKey(video.title)}`}
                state={{ video: video }}
                className="block"
                style={{ height: 200 }}
              >
                <PreviewImage media={video} type={'tv'} hud={true} />
              </Link>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
